





































































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { GapMemberCallReportFilter } from "@/store/modules/types";
import CallDateFilter from "@/components/report/filters/CreatedDate.vue";

@Component({
  components: {
    CallDateFilter
  },
  computed: mapState("gaps", ["insurers","campaigns"])
})
export default class MemberSearch extends Vue {
  @Model("change") readonly filter!: GapMemberCallReportFilter;
  lastShownFilter!: string;
  showCreatedDateFilter = false;
  showLogDateFilter = false;

  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter);
    }
    let show = false;
    switch (filter) {
      case "CREATED_DATE":
        show = !this.showCreatedDateFilter;
        this.showCreatedDateFilter = show;
        break;
      case "LOG_DATE":
        show = !this.showLogDateFilter;
        this.showLogDateFilter = show;
        break;
    }
    this.lastShownFilter = show ? filter : "";
  }
}
